import React from 'react';
import PropTypes from 'prop-types';
import {Box, Button, ButtonBase, CircularProgress, Typography} from '@mui/material';
import * as STYLE_CONSTANTS from '../../../styles/styleConstants';
import CustomViewMenu from './customViewMenu';
import {useGotIt} from '../../../hooks/useGotIt';

export const ListViewHeader = (props) => {

  //const [openSearch, setOpenSearch] = useState(false);
  //const [searchText, setSearchText] = useState('');
  const {extendedFilters, handleClick, gridEnum, menuController, title, viewController} = props;
  //const [selectedDate, setSelectedDate] = useState();
  const gotItPopupExport = useGotIt();

  // useEffect( () => {
  //   setSelectedDate(props.createdFromDate);

  // }, [props.createdFromDate])

  /** Export must always clear the spinner: without the finally the failed export left it running forever. */
  const handleExportFilteredData = async()=> {

    //console.log('send email => ', props.sendEmail);
    //console.log("total items => ", props.totalItemsCount);

    const viaEmail = Boolean(props.sendEmail) && Number(props.totalItemsCount) > 2000;

    viewController.setLoading(true);
    try {
      if (viaEmail) {
        await viewController.exportToEmail();
        gotItPopupExport.setShow('Request has been submitted, you will receive email shortly based on amount of data exported.');
      } else {
        await viewController.exportFilteredData();
        gotItPopupExport.setShow('Request has been downloaded.');
      }
    } catch (e) {
      const reason = e?.response?.data?.message || e?.message || 'unexpected error';
      gotItPopupExport.setShow(`Export failed: ${reason}. Please try again, or narrow the filters to export fewer records.`);
    } finally {
      viewController.setLoading(false);
    }
  };

  // const handleEmailExcel = async() => {
  //   viewController.setLoading(true);
  //   await viewController.exportToEmail();
  //   viewController.setLoading(false);
  // }



  // const datePickerHandler = (newDate)=>{
  //   if(newDate !== setSelectedDate) {
  //     setSelectedDate(newDate);
  //   }
  // };
  // useEffect ( () => {
  //   if (!selectedDate) return;

  //   props.createdFromDateChange(selectedDate);

  // },[selectedDate]);


  // const handleSearchOpen = () => {
  //   setSearchText('');
  //   setOpenSearch(true);
  // }

  // const handleSearchClose = () => setOpenSearch(false);

  // const handleSearch = () => {

  //   if (props.createFilterForSearchText && searchText.length > 2) {
  //     props.createFilterForSearchText(searchText);
  //   }
  //   handleSearchClose();
  // };

  const showTitleButton = Boolean(
    handleClick ||
    (title != null && String(title).trim() !== '') ||
    (gridEnum && gridEnum.length !== 1),
  );

  return (
    <>

      <Box
        display={'flex'}
        alignItems={'center'}
        flexWrap={'wrap'}
        rowGap={0.5}
        columnGap={1}
        sx={{minHeight: 36}}
      >
        {extendedFilters && extendedFilters.controller}
        {showTitleButton && (
          <ButtonBase disableRipple={false} onClick={handleClick || undefined}>
            {title != null && String(title).trim() !== '' && (
              <Typography variant={'h5'} sx={{marginRight: gridEnum && gridEnum.length !== 1 ? '16px' : 0}}>
                {title}
              </Typography>
            )}
            {gridEnum && gridEnum.length !== 1 && menuController?.controller}
          </ButtonBase>
        )}
        {menuController && menuController.menuItems}
        {/* {props.createFilterForSearchText && <IconButton
          aria-label="search"
          color="primary"         // or "secondary", "inherit", etc.
          size="large"            // or "small", "medium"
          onClick={handleSearchOpen}
        >
          <SearchIcon />
        </IconButton>}    */}
        {/* {props.createdFromDate && <div style={{ position: 'relative', display: 'inline-block' }}>
          <label
            htmlFor="date-input"
            style={{
              position: 'absolute',
              top: '-4px',
              backgroundColor: 'white',
              fontSize: '0.75rem',
              padding: '0 0.50rem',
              lineHeight: 1,
              color: '#555',
            }}
          >
            Created Since
          </label>
          <input
            id="date-input"
            type="date"
            value={selectedDate}
            onClick={() => {
              // Clear value every time user opens calendar
              setSelectedDate(null);
            }}
            onChange={(e) => {
              setSelectedDate(e.target.value);
            }}
            style={{
              border: '1px solid #ccc',
              borderRadius: '4px',
              width: '130px',
              padding: '0 0.50rem',
              margin: 0,
              fontSize: '0.9rem',
              height: '2rem',
              boxSizing: 'border-box',
            }}
          />
         </div>} */}

        {props.showCustomView && (
          <CustomViewMenu
            showCustomView={props.showCustomView}
            userId={viewController?.user.id}
            newCustomViewId={viewController?.newCustomViewId}
            origView={gridEnum[menuController.viewGrid].title}
            changeCurrentView={props.changeCurrentView}
          />
        )}
        {viewController && (
          <Box display="flex" alignItems="center" flexWrap="wrap" columnGap={1} rowGap={0.5}>
            <Typography variant="body2" sx={{lineHeight: 1, mr: 0.25}} component="span">
              Export:
            </Typography>
            <Box display="flex" alignItems="center" flexWrap="wrap" columnGap={0.5}>
              <Button sx={{minWidth: 'unset', padding: '4px 2px', color: STYLE_CONSTANTS.COLORS.linkColor}}
                onClick={viewController.exportAll}>Page</Button>
              <Typography variant="body2" sx={{lineHeight: 1, color: 'text.secondary'}} component="span">or</Typography>
              <Button sx={{minWidth: 'unset', padding: '4px 2px', color: STYLE_CONSTANTS.COLORS.linkColor}}
                onClick={viewController.exportChecked}>Checked</Button>
              <Typography variant="body2" sx={{lineHeight: 1, color: 'text.secondary'}} component="span">or</Typography>
              <Button sx={{minWidth: 'unset', padding: '4px 2px', color: STYLE_CONSTANTS.COLORS.linkColor}}
                onClick={handleExportFilteredData}>All Pages</Button>
            </Box>
            {viewController.isLoading && (
              <Box display="flex" justifyContent="center" alignItems="center" gap={1} sx={{width: '100%', flexBasis: '100%'}}>
                <CircularProgress size={22} variant="indeterminate" color="success" />
                <Typography color="error" variant="body2">
                  Please wait!
                </Typography>
              </Box>
            )}
            {gotItPopupExport.PopUp()}
          </Box>
        )}
        {/* <Button sx={{minWidth: 'unset', padding: '4px', color: STYLE_CONSTANTS.COLORS.linkColor}}
            onClick={handleEmailExcel}>Email Excel</Button> */}
      </Box>
      {/* <Dialog open={openSearch} onClose={handleSearchClose}>
        <DialogTitle>Search</DialogTitle>
        <DialogContent>
          <div style={{ position: 'relative', display: 'inline-block' }}>
            <InputLabel shrink htmlFor={'search-text'}
                required={false}
                sx={{
                  fontSize: {xs: '12px', md: '14px'},
                  fontWeight: '900',
                  padding: '0px 30px 0 10px',
                  margin: '0 0 0 0',
                  textTransform: 'capitalize !important',
                  //transform: {xs: 'translate(10px, -2px)', md: 'translate(10px, -4px)'},
                  color: COLORS.globalBlue,
                  zIndex: 1
                }}>
                Search Text
            </InputLabel>
            <input autoFocus
              id="search-text"
              type="text"
              value={searchText}
              autoComplete="off" 
              onChange={(e) => setSearchText(e.target.value)}
              style={{
                border: '1px solid #ccc',
                borderRadius: '8px',
                width: '350px',
                padding: '0 0.50rem',
                margin: '0 -6px 0 0',
                fontSize: '0.9rem',
                height: '2.5rem',
                boxSizing: 'border-box',
              }}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSearchClose}>Cancel</Button>
          <Button onClick={handleSearch} variant="contained" 
             disabled={searchText.trim().length < 3}
          >Search</Button>
        </DialogActions>
      </Dialog> */}
    </>
  );
};

ListViewHeader.propTypes = {
  extendedFilters: PropTypes.instanceOf(Object),
  handleClick: PropTypes.func,
  //gridEnum: PropTypes.arrayOf(PropTypes.string),
  gridEnum: PropTypes.arrayOf(PropTypes.instanceOf(Object)),
  menuController: PropTypes.instanceOf(Object),
  title: PropTypes.string,
  viewController: PropTypes.instanceOf(Object),
};

ListViewHeader.defaultProps = {
  extendedFilters: null,
  handleClick: null,
  gridEnum: null,
  menuController: null,
  title: '',
  viewController: null,
};
